import { Theme } from '@emotion/react'
import { Cancel, Edit } from '@mui/icons-material'
import { SxProps, Box, IconButton } from '@mui/material'
import { useState } from 'react'

export interface IconRowEntry {
  icon: JSX.Element
  title: string
  action: () => void
  sx?: SxProps<Theme>
}

export interface IconRowSelectorProps {
  icons: IconRowEntry[]
  sx?: SxProps<Theme>
  disabled?: boolean
}

export function IconRowSelector(props: IconRowSelectorProps): React.ReactElement {
  const { sx, icons, disabled } = props
  const [editing, setEditing] = useState(false)

  if (editing) {
    return <Box sx={{ display: 'inline-block', ...sx }}>
    <IconButton onClick={() => setEditing(false)}><Cancel/></IconButton>
    {icons.map((entry, idx) => <IconButton
      key={idx}
      onClick={() => { setEditing(false); entry.action() }}
      title={entry.title}
      sx={entry.sx}
    >
      {entry.icon}
    </IconButton>)}
  </Box>

  } else {
    return <Box sx={{ display: 'inline-block', ...sx }}>
      <IconButton disabled={disabled} onClick={() => setEditing(true)}><Edit/></IconButton>
    </Box>
  }
}
